var favicon = require("./favicons/simply/favicon-32x32.png");

export default {
  isSimplyBased: false,
  favicon: favicon,
  padding: "8px",
  radius: "6px",
  border_width: "1px",
  logo: false,
  logo_text: false,
  logo_link: false,
  logo_fineprint: false,
  minheight: "calc(100vh - 300px)",
  margintop: "80px",
  google_font: "Lato",
  font_headings: "Lato, Helvetica, Arial, sans-serif",
  font_body: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif',
  fonts: {
    h1: {
      desktop: "600 2.5rem Lato, Helvetica, Arial, sans-serif",
      mobile: "600 2.5rem Lato, Helvetica, Arial, sans-serif"
    },
    h2: {
      desktop: "600 2rem Lato, Helvetica, Arial, sans-serif",
      mobile: "600 2rem Lato, Helvetica, Arial, sans-serif"
    },
    h3: {
      desktop: "600 1.75rem Lato, Helvetica, Arial, sans-serif",
      mobile: "600 1.75rem Lato, Helvetica, Arial, sans-serif"
    },
    h4: {
      desktop: "600 1.5rem Lato, Helvetica, Arial, sans-serif",
      mobile: "600 1.5rem Lato, Helvetica, Arial, sans-serif"
    },
    h5: {
      desktop: "600 1.25rem Lato, Helvetica, Arial, sans-serif",
      mobile: "600 1.25rem Lato, Helvetica, Arial, sans-serif"
    },
    h6: {
      desktop: "600 1rem/1.7rem Lato, Helvetica, Arial, sans-serif",
      mobile: "600 1rem/1.7rem Lato, Helvetica, Arial, sans-serif"
    },
    p: {
      desktop: '1rem/1.7rem -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif',
      mobile: '1rem/1.7rem -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif'
    },
    li: {
      desktop: '1rem/1.7rem -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif',
      mobile: '1rem/1.7rem -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif'
    }
  },
  avatar: {
    sizes: {
      small: "32px",
      medium: "64px",
      large: "104px"
    }
  },
  dropdown: {
    sizes: {
      small: {
        min: "144px",
        max: "179px"
      },
      medium: {
        min: "180px",
        max: "264px"
      },
      fluid: {
        min: "100%",
        max: "100%"
      }
    }
  },
  fontSizes: {
    base: "1rem"
  },
  spaces: {
    superLoose: "4rem",
    extraLoose: "3rem",
    loose: "2rem",
    bitLoose: "1rem",
    base: "1.5625rem;",
    basePlus: "1.6625rem;",
    tight: "1rem",
    extraTight: ".78125rem",
    cellheight: "120px"
  },
  boxShadow: {
    size: {
      "100": "0 0 1px 0 rgba(0,12,32,.04), 0 10px 16px 0 rgba(10,31,68,.06)",
      "200": "0 6px 20px 0 rgba(0,12,32,.04), 0 8px 17px 0 rgba(10,31,68,.06)",
      "300": "0 12px 15px 0 rgba(0,12,32,.04), 0 17px 50px 0 rgba(10,31,68,.06)",
      "400": "0 16px 28px 0 rgba(0,12,32,.04), 0 25px 55px 0 rgba(10,31,68,.06)",
      "500": "0 27px 24px 0 rgba(0,12,32,.04), 0 40px 77px 0 rgba(10,31,68,.06)"
    }
  },
  animation: {
    speed: {
      base: ".5s",
      slow: ".4s",
      slower: ".3s",
      slowest: ".2s",
      fast: ".1s"
    },
    ease: {
      base: "cubic-bezier(0.65, 0, 0.37, 1)",
      in: "cubic-bezier(0.40, 0, 1, 1)",
      out: "cubic-bezier(0, 0, 0.41, 1)",
      leap: "cubic-bezier(0.18, 0.67, 0.6, 1.22)",
      overshoot: "cubic-bezier(0.05, 0.28, 0.33, 1.25)",
      impulse: "cubic-bezier(0.39, -0.5, 0.90, 0.66)"
    }
  },
  colours: {
    transparent: "transparent",
    primary: {
      darkest: "#0B3F78",
      darker: "#125995",
      dark: "#1B76B2",
      base: "#2597D0",
      light: "#56BDE2",
      lighter: "#7AD8F0",
      lightest: "#A7EEFA",
      light_text: "#fff",
      dark_text: "#1a202c",
      border_colour: "transparent",
      gradient: "linear-gradient(45deg, #1287BF 0%, #2597D0 100%);",
      gradient_hover: "linear-gradient(45deg, #0876AC 0%, #1287BF 100%);"
    },
    secondary: {
      darkest: "#055E32",
      darker: "#097A22",
      dark: "#15960E",
      base: "#49B014",
      light: "#66C237",
      lighter: "#83D15B",
      lightest: "#A2DF82",
      light_text: "#fff",
      dark_text: "#1a202c",
      border_colour: "transparent",
      gradient: "linear-gradient(45deg, #097A22 0%, #49B014 100%);",
      gradient_hover: "linear-gradient(45deg, #49B014 0%, #66C237 100%);"
    },
    tertiary: {
      darkest: "#970b31",
      darker: "#b91840",
      dark: "#d42851",
      base: "#e83c64",
      light: "#ee6c97",
      lighter: "#f39cc1",
      lightest: "#f9cce3",
      light_text: "#fff",
      dark_text: "#1a202c",
      border_colour: "transparent",
      gradient: "linear-gradient(45deg, #d42851 0%, #e83c64 100%);",
      gradient_hover: "linear-gradient(45deg, #b91840 0%, #d42851 100%);"
    },
    ghost: {
      darkest: "transparent",
      darker: "transparent",
      dark: "transparent",
      base: "transparent",
      light: "transparent",
      lighter: "transparent",
      lightest: "transparent",
      light_text: "#2597D0",
      dark_text: "#0876AC",
      border_colour: "#2597D0",
      gradient: "none",
      gradient_hover: "none"
    },
    "ghost-secondary": {
      darkest: "transparent",
      darker: "transparent",
      dark: "transparent",
      base: "transparent",
      light: "transparent",
      lighter: "transparent",
      lightest: "transparent",
      light_text: "#15960E",
      dark_text: "#097A22",
      border_colour: "#097A22",
      gradient: "none",
      gradient_hover: "none"
    },
    "ghost-tertiary": {
      darkest: "transparent",
      darker: "transparent",
      dark: "transparent",
      base: "transparent",
      light: "transparent",
      lighter: "transparent",
      lightest: "transparent",
      light_text: "#e83c64",
      dark_text: "#b91840",
      border_colour: "#e83c64",
      gradient: "none",
      gradient_hover: "none"
    },
    filled: {
      darkest: "#fff",
      darker: "#fff",
      dark: "#fff",
      base: "#fff",
      light: "#fff",
      lighter: "#fff",
      lightest: "#fff",
      light_text: "#2597D0",
      dark_text: "#0876AC",
      border_colour: "#2597D0",
      gradient: "none",
      gradient_hover: "none"
    },
    neutral: {
      darkest: "#5c6e77",
      darker: "#798c95",
      dark: "#92a2a9",
      base: "#d1d6da",
      light: "#bbc5c9",
      lighter: "#ccd4d7",
      lightest: "#fff",
      light_text: "#2597D0",
      dark_text: "#1a202c",
      border_colour: "transparent",
      gradient: "none",
      gradient_hover: "none"
    },
    success: {
      darkest: "#92D553",
      darker: "#92D553",
      dark: "#92D553",
      base: "#92D553",
      light: "#92D553",
      lighter: "#92D553",
      lightest: "#92D553",
      light_text: "#92D553",
      dark_text: "#92D553",
      border_colour: "transparent",
      gradient: "none",
      gradient_hover: "none"
    },
    danger: {
      darkest: "#930E2E",
      darker: "#B7162F",
      dark: "#DB202D",
      base: "#FF312D",
      light: "#FF7161",
      lighter: "#FF9881",
      lightest: "#FFC2AB",
      light_text: "#fff",
      dark_text: "#662222",
      border_colour: "transparent",
      gradient: "none",
      gradient_hover: "none"
    },
    "danger-ghost": {
      darkest: "transparent",
      darker: "transparent",
      dark: "transparent",
      base: "transparent",
      light: "transparent",
      lighter: "transparent",
      lightest: "transparent",
      light_text: "#fff",
      dark_text: "#662222",
      border_colour: "#FF312D",
      gradient: "none",
      gradient_hover: "none"
    }
  }
};